import gql from 'graphql-tag'

const apollo = {
    tasks: gql`query tasks($cate: String!,$userId:String){
		tasks(cate:$cate,userId:$userId){
			name,
			id,
			assignTime,
			uri,
			process{
				id,
				name,
				uri,
				tags,
				entry,
				owner{
					id,
					name,
					account
				}
				app{
					name,
					system
				}
			}
		}
	}`,
    processes: gql`query processes($cate:String!,$userId:String,$page:Int,$size:Int){
		processes(cate:$cate,userId:$userId,page:$page,size:$size){
			total,
			processes{
				id,
			    name,
			    uri,
			    entry,
			    pendingTasks,
			    update,
			    app{
			    	name
			    }
			}
		}
	}`,
    faq: gql`query question($id: String, $start: Int, $limit: Int, $keyword: String, $status: Int, $recommStatus: Int, $quesLabel: String, $startLabel: String) {
		standardQuestions(id: $id, similar: true, start: $start, limit: $limit, keyword: $keyword, status: $status, recommStatus: $recommStatus, quesLabel: $quesLabel, startLabel:, $startLabel) {
		    totalCount
             edges {
                node {
                  id
                  question
                  quesCode
                  quesLabel
                  quesDesc
                  createTime
                  updateTime
                  status
                  recommStatus
                  similarCount
                  recommCount
                  slots {
                    id
                    slotName
                    slotAlias
                    entityDeclId
                    ask
                    isMust
                    __typename
                  }
                  answers {
                    id
                    answer
                    condition
                    __typename
                  }
                  similarQuestions {
                    edges {
                      node {
                        id
                        similarQues
                        stdQuesId
                        createTime
                        updateTime
                        isLabel
                        status
                      }
                    }
                  }
                }
             }
		}
	}`,
    guide: gql`query guide($first: Int,$offset: Int,$id: ID,$title: String,$stepTitle: String,$context: String,$keyword: String,$isRealease: Boolean,$state: Int,$appId: [String],$appTag: String,$appName: String,$appCode: [String]){
	    guide(first:$first,offset:$offset,id:$id,title:$title,stepTitle:$stepTitle,context:$context,keyword:$keyword,isRealease:$isRealease,state:$state,appId:$appId,appTag:$appTag,appName:$appName,appCode:$appCode){
	        totalCount
            edges{
              node{
                id
                title
                keyword
                mainpic
                isRealease
                createUser
                createUserAccount
                createTime
                updateTime
                updateUser
                updateUserAccount
                state
                guideStepList{
                  listId
                  context
                  guideId
                  stepNo
                  stepTitle
                  guideStepAppList{
                    listAppId
                    appId
                    appCode
                    appName
                    appTag
                    appUrl
                    guideId
                    guideStepId
                  }
                }
              }
            }
	    }
	}`,
    //机器人信息
    robotInfo: gql`query robotInfo($start:Int, $limit:Int,$keyword:String,$id: String, $tenantId: String,$status: String){
	    robotInfos(start:$start,limit:$limit,keyword:$keyword,id:$id,tenantId:$tenantId,status:$status){
		    totalCount
            edges{
              node{
                id
                name
                image
                welcomes
                voiceType
                status
                }
            }
        }
	}`,
    getPosts: gql`query getPosts($id: ID $first: Int $last: Int $before: String $after: String $offset: Int $filter: Filter $keywords: String $tags: String) {
        posts(id: $id first: $first last: $last before: $before after: $after offset: $offset filter: $filter keywords: $keywords tags: $tags) {
          edges {
            node {
              id
            }
          }
        }
  	}`
}
export default apollo;


// WEBPACK FOOTER //
// ./src/graphql/apollo.js